import { useEffect } from 'react';
import type { DirectFcfsCapacityPool } from 'src/apis/direct-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleError } from 'src/utils/handle-error';
import { reportToSentry } from 'src/utils/report-to-sentry';

export function useDirectFcfsCapacityPools(networkPointId: string) {
  const capacityPoolsData = useAxios(
    (axios, baseConfig, networkPointId: string) =>
      axios.request<DirectFcfsCapacityPool[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.directFcfs}/network-points/${networkPointId}/capacity-pools`,
        method: 'GET',
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    capacityPoolsData.execute(networkPointId);
    // oxlint-disable-next-line exhaustive-deps
  }, [networkPointId]);

  return capacityPoolsData;
}

export type DirectFcfsCapacityPoolsRequest = ReturnType<
  typeof useDirectFcfsCapacityPools
>;

export function useOptionalDirectFcfsCapacityPools(networkPointId: string) {
  const capacityPoolsData = useAxios(
    (axios, baseConfig, networkPointId: string) =>
      axios.request<DirectFcfsCapacityPool[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.directFcfs}/network-points/${networkPointId}/capacity-pools`,
        method: 'GET',
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        const [_, report] = handleError(error, () => {});
        if (report) reportToSentry(error);
        return error;
      },
    }
  );

  useEffect(() => {
    capacityPoolsData.execute(networkPointId);
    // oxlint-disable-next-line exhaustive-deps
  }, [networkPointId]);

  return capacityPoolsData;
}

export type OptionalDirectFcfsCapacityPoolsRequest = ReturnType<
  typeof useOptionalDirectFcfsCapacityPools
>;
